
























import { defineComponent, ref, computed } from "@vue/composition-api";
import * as Cookies from "tiny-cookie";
import { $t } from "@/lib/i18nHelpers";
import { getLocale } from "@/lib/localeHelper";
import BaseIcon from "@/components/BaseIcon";

interface SelectOption {
  label: string;
  value: string;
}

export default defineComponent({
  name: "LocaleSwitchItem",
  components: { BaseIcon },
  setup(props, { root }) {
    const showSelect = ref(false);
    const currentLocale = ref(getLocale().substring(0, 2));

    const items = computed<SelectOption[]>(() => [
      {
        label: $t("English"),
        value: "en",
      },
      {
        label: $t("Spanish"),
        value: "es",
      },
      {
        label: $t("Portuguese"),
        value: "pt",
      },
    ]);

    const currentLocaleTitle = computed(
      () => items.value.find(i => i.value === currentLocale.value)?.label ?? $t("English")
    );

    const onEnter = (el: HTMLElement, done: Function) => {
      const { height, bottom } = el.getBoundingClientRect();
      const position = {
        top: "",
        bottom: "",
      };
      if (window.innerHeight - bottom < height) {
        position.top = "unset";
        position.bottom = "100%";
      } else {
        position.top = `100%`;
        position.bottom = "none";
      }
      if (position) {
        el.style.setProperty("--top-position", position.top);
        el.style.setProperty("--bottom-position", position.bottom);
      }
      done();
    };

    const handleLocaleChange = (value: string) => {
      if (value !== currentLocale.value) {
        currentLocale.value = value;
        root.$i18n.locale = value;
        Cookies.set("locale", value, { expires: "30Y" });
      }
      showSelect.value = false;
    };

    return { showSelect, items, handleLocaleChange, currentLocale, currentLocaleTitle, onEnter };
  },
});
